import Vue from 'vue'

export const languageUtil = {
    
    getLanguages() {
        
        let selector = [];

        Vue.prototype.$Params.idiomas.split(',').forEach(lng => {
            switch(lng) {
                case 'es': selector.push({id: lng, desc: 'Español'}); break;
                case 'ca': selector.push({id: lng, desc: 'Català'}); break;
                case 'en': selector.push({id: lng, desc: 'English'}); break;
            }
        });

        return selector;
    }
};